import _slicedToArray from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray";
import _defineProperty from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React, { useEffect, useRef, useState } from 'react';
import styled, { useTheme } from 'styled-components';
import { Box, Link as CoreLink, Button as CoreButton, useWindowSize } from '@miro-site/core';
import SecondaryNavigation from './SecondaryNavigation';
import Highlighted from './Highlighted';
import CustomerSpotlight from './CustomerSpotlight';
import TemplatesHighilighted from './TemplatesHighlighted';
import { Transition } from 'react-transition-group';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var Link = styled(CoreLink).withConfig({
  displayName: "TopNavigation__Link",
  componentId: "sc-v43aug-0"
})(["display:block;white-space:nowrap;", ""], function (_ref) {
  var theme = _ref.theme;
  return theme.normalizeStyles({
    transition: "color ".concat(theme.animation.transitionDuration),
    fontSize: theme.header.topNavigation.fontSize,
    lineHeight: theme.header.topNavigation.lineHeight,
    color: theme.header.topNavigation.color,
    ':hover': {
      color: theme.header.topNavigation.hoverColor
    },
    ':focus': _objectSpread({}, theme.focus.outlines.withOffset)
  });
});

var getChevronBackground = function getChevronBackground(color) {
  return "url(\"data:image/svg+xml,%3Csvg width='12' height='8' viewBox='0 0 12 8' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M1 1L6 6L11 1' stroke='".concat(encodeURIComponent(color), "' stroke-width='1.5'/%3E%3C/svg%3E%0A\")");
};

var Button = styled(CoreButton).attrs(function (props) {
  return {
    'data-top-navigation-button': 1,
    'aria-haspopup': true,
    'aria-expanded': !!props.$isExpanded
  };
}).withConfig({
  displayName: "TopNavigation__Button",
  componentId: "sc-v43aug-1"
})(["", ""], function (_ref2) {
  var theme = _ref2.theme,
      $isExpanded = _ref2.$isExpanded;
  return theme.normalizeStyles({
    transition: "color ".concat(theme.animation.transitionDuration),
    fontSize: theme.header.topNavigation.fontSize,
    lineHeight: theme.header.topNavigation.lineHeight,
    color: $isExpanded ? theme.header.topNavigation.hoverColor : theme.header.topNavigation.color,
    ':hover': {
      color: theme.header.topNavigation.hoverColor,
      '.focus-trap:after': {
        backgroundImage: getChevronBackground(theme.header.topNavigation.hoverColor)
      }
    },
    ':focus': _objectSpread({}, theme.focus.outlines.withOffset),
    '.focus-trap:after': {
      transition: theme.header.topNavigation.animation.chevron,
      transform: $isExpanded ? 'rotate(-180deg)' : 'rotate(0)',
      display: 'inline-block',
      marginLeft: 8,
      content: "''",
      width: 10,
      height: 10,
      backgroundRepeat: 'no-repeat',
      backgroundPosition: 'center',
      backgroundImage: getChevronBackground($isExpanded ? theme.header.topNavigation.hoverColor : theme.colors.primaryIndigo),
      position: 'relative',
      top: [null, 2, 2, 2, null]
    }
  });
});
var List = styled(Box).attrs(function (_ref3) {
  var theme = _ref3.theme;
  return {
    as: 'ul',
    role: 'menu',
    $styles: {
      display: 'flex',
      alignItems: 'center'
    }
  };
}).withConfig({
  displayName: "TopNavigation__List",
  componentId: "sc-v43aug-2"
})(["", ",", "{display:block;}"], Link, Button);
List.displayName = 'TopNavigation.List';
var Container = styled(Box).attrs(function (_ref4) {
  var theme = _ref4.theme;
  return {
    $styles: {
      display: ['none', 'none', 'flex'],
      marginLeft: theme.header.topNavigation.leftOffset,
      alignItems: 'center',
      alignSelf: 'stretch'
    }
  };
}).withConfig({
  displayName: "TopNavigation__Container",
  componentId: "sc-v43aug-3"
})([""]);
Container.displayName = 'TopNavigation.Container';

var LinkIndicator = function LinkIndicator(props) {
  var activeNavigation = props.activeNavigation,
      activeItemRef = props.activeItemRef;

  var _useState = useState([0, 0]),
      indicatorPosition = _useState[0],
      setIndicatorPosition = _useState[1];

  var theme = useTheme();

  var _useWindowSize = useWindowSize(),
      width = _useWindowSize.width;

  var _indicatorPosition = _slicedToArray(indicatorPosition, 2),
      indicatorOffset = _indicatorPosition[0],
      indicatorWidth = _indicatorPosition[1];

  useEffect(function () {
    if (activeItemRef.current) {
      var item = activeItemRef.current;
      var itemOffset = item.offsetLeft;
      var itemRect = item.getBoundingClientRect();
      var itemComputedStyle = window.getComputedStyle(item, null);
      var paddingLeft = parseFloat(itemComputedStyle.paddingLeft);
      var paddingRight = parseFloat(itemComputedStyle.paddingRight);
      var itemWidth = itemRect.width - paddingLeft - paddingRight;
      setIndicatorPosition([itemOffset + paddingLeft, itemWidth]);
    } else {
      setIndicatorPosition(function (prev) {
        return [prev[0], 0];
      });
    }
  }, [activeNavigation, width]);
  var states = {
    entering: {
      transition: 'none 0s ease 0s',
      transform: "translateX(".concat(indicatorOffset, "px) scaleX(0)")
    }
  };
  return /*#__PURE__*/_jsx(Transition, {
    "in": activeNavigation !== null,
    timeout: 0,
    children: function children(state) {
      return /*#__PURE__*/_jsx(Box, {
        $styles: _objectSpread({
          transformOrigin: 'left',
          transition: theme.header.topNavigation.animation.linkIndicator,
          transform: "translateX(".concat(indicatorOffset, "px) scaleX(").concat(indicatorWidth / 100, ")"),
          position: 'absolute',
          left: 0,
          bottom: 0,
          width: '100px',
          height: 2,
          background: theme.colors.primaryBlueHover
        }, states[state] || {})
      });
    }
  });
};

LinkIndicator.displayName = 'LinkIndicator';
var Item = styled.li.attrs({
  role: 'menuitem'
}).withConfig({
  displayName: "TopNavigation__Item",
  componentId: "sc-v43aug-4"
})(["", ""], function (props) {
  return props.theme.normalizeStyles({
    paddingLeft: props.theme.header.topNavigation.gutter,
    paddingRight: props.theme.header.topNavigation.gutter,
    ':first-child': {
      paddingLeft: 0
    },
    ':last-child': {
      paddingRight: 0
    }
  });
});
Item.displayName = 'TopNavigation.Item';

var TopNavigation = function TopNavigation(props) {
  var activeNavigation = props.activeNavigation,
      activeNavigationRef = props.activeNavigationRef,
      onToggleNavigation = props.onToggleNavigation,
      productNavigation = props.productNavigation,
      whatsNew = props.whatsNew,
      solutionsNavigation = props.solutionsNavigation,
      templates = props.templates,
      resourcesNavigation = props.resourcesNavigation,
      customerSpotlight = props.customerSpotlight,
      enterpriseLink = props.enterpriseLink,
      pricingLink = props.pricingLink;
  var prevNavigation = useRef(null);
  var activeItemRef = useRef(null);
  useEffect(function () {
    prevNavigation.current = activeNavigation;
  }, [activeNavigation]);

  var setActiveNavigationRef = function setActiveNavigationRef(navigationIndex, ref) {
    if (!activeNavigationRef) {
      return;
    }

    if (activeNavigation === null) {
      activeNavigationRef.current = null;
    }

    if (navigationIndex === activeNavigation) {
      activeNavigationRef.current = ref;
    }
  };

  var setactiveItemRef = function setactiveItemRef(navigationIndex, ref) {
    if (activeNavigation === null) {
      activeItemRef.current = null;
    }

    if (navigationIndex === activeNavigation) {
      activeItemRef.current = ref;
    }
  };

  return /*#__PURE__*/_jsxs(Container, {
    children: [/*#__PURE__*/_jsxs(List, {
      children: [/*#__PURE__*/_jsxs(Item, {
        ref: function ref(_ref6) {
          return setactiveItemRef(0, _ref6);
        },
        $isExpanded: activeNavigation === 0,
        children: [/*#__PURE__*/_jsx(Button, {
          "data-track-id": "top-navigation-button",
          "aria-controls": 'product-navigation',
          $isExpanded: activeNavigation === 0,
          onClick: function onClick() {
            return onToggleNavigation(0);
          },
          children: productNavigation.title
        }), /*#__PURE__*/_jsx(SecondaryNavigation, {
          id: 'product-navigation',
          ref: function ref(_ref5) {
            return setActiveNavigationRef(0, _ref5);
          },
          index: 0,
          prevNavigation: prevNavigation.current,
          nextNavigation: activeNavigation,
          navigationGroups: productNavigation.groups,
          highlightedContent: /*#__PURE__*/_jsx(Highlighted, _objectSpread({}, whatsNew))
        })]
      }), /*#__PURE__*/_jsxs(Item, {
        ref: function ref(_ref8) {
          return setactiveItemRef(1, _ref8);
        },
        $isExpanded: activeNavigation === 1,
        children: [/*#__PURE__*/_jsx(Button, {
          "data-track-id": "top-navigation-button",
          "aria-controls": 'solutions-navigation',
          $isExpanded: activeNavigation === 1,
          onClick: function onClick() {
            return onToggleNavigation(1);
          },
          children: solutionsNavigation.title
        }), /*#__PURE__*/_jsx(SecondaryNavigation, {
          id: 'solutions-navigation',
          ref: function ref(_ref7) {
            return setActiveNavigationRef(1, _ref7);
          },
          index: 1,
          prevNavigation: prevNavigation.current,
          nextNavigation: activeNavigation,
          navigationGroups: solutionsNavigation.groups,
          highlightedContent: /*#__PURE__*/_jsx(TemplatesHighilighted, _objectSpread({}, templates))
        })]
      }), /*#__PURE__*/_jsxs(Item, {
        ref: function ref(_ref10) {
          return setactiveItemRef(2, _ref10);
        },
        $isExpanded: activeNavigation === 2,
        children: [/*#__PURE__*/_jsx(Button, {
          "data-track-id": "top-navigation-button",
          "aria-controls": 'resources-navigation',
          $isExpanded: activeNavigation === 2,
          onClick: function onClick() {
            return onToggleNavigation(2);
          },
          children: resourcesNavigation.title
        }), /*#__PURE__*/_jsx(SecondaryNavigation, {
          id: 'resources-navigation',
          ref: function ref(_ref9) {
            return setActiveNavigationRef(2, _ref9);
          },
          index: 2,
          prevNavigation: prevNavigation.current,
          nextNavigation: activeNavigation,
          navigationGroups: resourcesNavigation.groups,
          highlightedContent: /*#__PURE__*/_jsx(CustomerSpotlight, _objectSpread({}, customerSpotlight))
        })]
      }), /*#__PURE__*/_jsx(Item, {
        children: /*#__PURE__*/_jsx(Link, {
          href: enterpriseLink.path,
          children: enterpriseLink.title
        })
      }), /*#__PURE__*/_jsx(Item, {
        children: /*#__PURE__*/_jsx(Link, {
          href: pricingLink.path,
          children: pricingLink.title
        })
      })]
    }), /*#__PURE__*/_jsx(LinkIndicator, {
      activeNavigation: activeNavigation,
      activeItemRef: activeItemRef
    })]
  });
};

export default Object.assign(TopNavigation, {
  Link: Link,
  Button: Button,
  Item: Item
});